// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-lighting.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-lighting/aerodrome-lighting.js';

mount([g0]);
